import React, { useEffect, useState } from "react";
import "./ExportFieldSelection.css";
import CommonModal from "../ModalComponent/CommonModal";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import CheckboxComponent from "../CheckboxComponent/CheckboxComponent";

const ExportFieldSelection = ({ data = [], onExport, onClose }) => {
    const [fields, setFields] = useState([]);
    const [selectedFields, setSelectedFields] = useState([]);

    useEffect(() => {
        if (!data.length) return;

        const keys = Object.keys(data[0]).filter(
            key =>
                ![
                    "MaxRows",
                    "RowNumber",
                    "id",
                    "isactive"
                ].includes(key)
        );

        setFields(keys);
        setSelectedFields(keys);
    }, [data]);

    const handleToggle = field => {
        setSelectedFields(prev => {
            if (prev.includes(field)) {
                return prev.filter(item => item !== field);
            }

            return [...prev, field];
        });
    };

    const handleSelectAll = () => {
        setSelectedFields(fields);
    };

    const handleClearAll = () => {
        setSelectedFields([]);
    };

    const handleExport = () => {
        if (selectedFields.length === 0) {
            alert("Please select at least one field.");
            return;
        }

        onExport(selectedFields);
    };

    return (
        <CommonModal
            maxWidth={'sm'}
            Title={"Select Fields"}
            ActionText={"Export Excel"}
            IsDeletePopup={false}
            IsLoading={false}
            onClose={onClose.bind(this)}
            IsScroll>

            <div className="export-modal">

                <div className="export-fields">
                    {fields.map(field => (
                        <label key={field} className="export-field" >

                            <CheckboxComponent
                                id={`header_${field}`}
                                label={field}
                                checked={selectedFields.includes(field)}
                                onChange={(e) => handleToggle(field)}
                            />

                        </label>
                    ))}
                </div>

                <div className="export-modal-footer">
                    <div className="export-actions">
                        <ButtonComponent onClick={() => handleSelectAll()}> Select All </ButtonComponent>
                        <ButtonComponent onClick={() => handleClearAll()}> Clear All </ButtonComponent>
                    </div>
                    <div>
                        <ButtonComponent onClick={handleExport}> Export </ButtonComponent>
                    </div>
                </div>
            </div>
        </CommonModal>
    );
};

export default ExportFieldSelection;